'use client';

import classNames from 'classnames';

import { ExternalLink } from '@uikit';

import { OctagramSoft } from '@uikit/icons/OctagramSoft';

import { GENERAL_URLS } from '@shared/constants/url';

import NewsletterSubscribeWidget from '@launchpad/components/pages/Main/ui/widgets/NewsletterSubscribeWidget';

import Socials from '../../common/Socials/Socials';
import Projects from './ui/Projects/Projects';

type Props = {
  withEarlyAccess?: boolean;
};

const Page = ({ withEarlyAccess }: Props) => {
  return (
    <main className="main-container py-16">
      <div
        className={classNames('mb-14 p-6 rounded-lg bg-primary-50', { hidden: !withEarlyAccess })}
      >
        <h1 className="mb-2 text-2xl font-semibold">
          Welcome to our Early Access Token Sale (EATS) page.
        </h1>
        <p>
          Here, you can participate in promising projects at their earliest stages, securing tokens
          at a lower price compared to the IDO price. Unlike IDOs, where tokens are launched
          immediately, EATS tokens will be launched at a later stage. This means you join knowing
          the token launch will take longer, but you benefit from a lower price due to the early
          stage of the project.
          <br />
          All allocations obtained through EATS can be traded on our{' '}
          <ExternalLink className="text-primary-600 underline" href={GENERAL_URLS.otc}>
            Pre-TGE Marketplace
          </ExternalLink>
          , allowing you to buy, sell, or trade your tokens before the official launch. This
          provides you with liquidity and flexibility as you support and benefit from the growth
          potential of these innovative projects.
        </p>
      </div>
      <Projects type="active" withEarlyAccess={withEarlyAccess} />
      <Projects type="coming" withEarlyAccess={withEarlyAccess} />
      <Projects type="passed" withEarlyAccess={withEarlyAccess} TitleIcon={OctagramSoft} />
      <NewsletterSubscribeWidget className="my-6 sm:mt-12 sm:mb-16" />
      <Socials />
    </main>
  );
};

export default Page;
